import React, {useEffect, useState} from 'react';
import { useLocation } from "react-router-dom";

import Title from "../../shared/components/Title";
import {findLecture} from "./infra/repository/FindLecture";
import './style/lecture.scss';
import {writingPracticeSubmit} from "./WritingPractice";
import { LetureNavigationMenu } from "./LetureNavigationMenu";

export default () => {
  const [page, setPage] = useState('');
  // get url params
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const pageId = params.get("pageId");

  const loadPage = async (pageId) => {

    try {
      const data = await findLecture(pageId);
      setPage(data);
    } catch (err) {
      console.log(err.message);
    }
  };


  useEffect(() => {
    if (pageId) {
      loadPage(pageId);
    }
  }, [pageId]); // Empty dependency array ensures this runs only once

  // Attach the correction handler once the page content is rendered.
  useEffect(() => {
    if (!page) return;
    const cleanup = writingPracticeSubmit();
    return cleanup;
  }, [page]);

  return (
    <div className="lecture__container">
      <div className="lecture__container--navigation-menu">
        <LetureNavigationMenu/>
      </div>
      <div className="lecture__container--view">
        <Title title={page.name}/>
        <div className='page-content'
             dangerouslySetInnerHTML={{__html: page.html}}
        />
      </div>
    </div>
  );
};